
.container {
  display: flex;
  align-items: center;
  gap: map.get($spacing-scale, 'sm');
  padding-bottom: map.get($spacing-scale, 'lg');
  padding-top: 0;
  width: 100%;
  max-width: 1200px;
  background: var(--color-background-primary);
}

.titleContainer {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  min-width: 0;
}

.title {
  flex: 1;
  @include body-large-medium;
  color: var(--color-text-primary);
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

.actions {
  display: flex;
  align-items: center;
  gap: map.get($spacing-scale, 'sm');
  flex-shrink: 0;
}

// Constrain leading icon to 14px inside page header action buttons
.actionButton svg {
  width: 14px;
  height: 14px;
}

// Responsive adjustments
@media (max-width: $breakpoint-md) {
  .container {
    flex-direction: column;
    align-items: stretch;
    gap: map.get($spacing-scale, 'md');
  }

  .titleContainer {
    justify-content: flex-start;
  }
}
